import { css } from 'styled-components';
import { getSpacingToken, getToken, Size } from '@optimus-web/common';

export const getValueContainerHeight = ({ size }: { size?: Size }) => {
    switch (size) {
        case 'small':
            return getToken('sizing400');
        case 'medium':
            return getToken('sizing500');
        case 'large':
            return getToken('sizing600');
        case 'extraLarge':
            return getToken('sizing700');
        default:
            return getToken('sizing500');
    }
};

export const getValueContainerVerticalPadding = (size?: Size, hasTags?: boolean) => {
    const getPaddingSize = (paddingSize?: Size) => {
        switch (paddingSize) {
            case 'small':
                return '50';
            case 'medium':
                return '100';
            case 'large':
                return '150';
            case 'extraLarge':
                return '200';
            default:
                return '100';
        }
    };

    if (hasTags) {
        return css`
            padding-top: calc(${getSpacingToken(getPaddingSize(size))}px - 2px);
            padding-bottom: calc(${getSpacingToken(getPaddingSize(size))}px - 3px);
        `;
    }

    return css`
        padding-top: ${getSpacingToken(getPaddingSize(size))}px;
        padding-bottom: ${getSpacingToken(getPaddingSize(size))}px;
    `;
};
